import { api } from "./apiClient";

const platformAPI = {
  getPublicPlans() {
    return api.get("/platform/public/plans").then((r) => r.data);
  },
  getFeaturesCatalog() {
    return api.get("/platform/features").then((r) => r.data);
  },
  getAnalytics() {
    return api.get("/platform/analytics").then((r) => r.data);
  },
  getAuditLogs(limit = 50) {
    return api
      .get("/platform/audit-logs", { params: { limit } })
      .then((r) => r.data);
  },
  getPlans() {
    return api.get("/platform/plans").then((r) => r.data);
  },
  createPlan(body) {
    return api.post("/platform/plans", body).then((r) => r.data);
  },
  updatePlan(id, body) {
    return api.patch(`/platform/plans/${id}`, body).then((r) => r.data);
  },
  deletePlan(id) {
    return api.delete(`/platform/plans/${id}`).then((r) => r.data);
  },
  getClinics() {
    return api.get("/platform/clinics").then((r) => r.data);
  },
  getClinic(id) {
    return api.get(`/platform/clinics/${id}`).then((r) => r.data);
  },
  updateClinicStatus(id, status) {
    return api.patch(`/platform/clinics/${id}`, { status }).then((r) => r.data);
  },
  updateClinicBilling(id, body) {
    return api
      .patch(`/platform/clinics/${id}/billing`, body)
      .then((r) => r.data);
  },
};

export default platformAPI;
